import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import overviewService from 'ApiService/Student/overviewService';
import { AuthContext } from 'contexts/AuthContext';
import RemainingTasks from './RemainingTasks';

const Index = () => {
  const [task, setTask] = useState({
    tests: [],
    assignments: [],
    practicalAssignments: [],
    practicalTests: [],
  });
  const { state } = useContext(AuthContext);
  const [loadingTask, setLoadingTask] = useState(true);

  const fetchTasksDetails = async () => {
    setLoadingTask(true);
    try {
      const response = await overviewService.getRemainingTasks();
      if (response?.data?.success) {
        setTask(response.data.incompleteTasks);
      } else {
        toast.error('Failed to fetch tasks.');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to fetch tasks.');
    } finally {
      setLoadingTask(false);
    }
  };

  useEffect(() => {
    if (state?.user) {
      fetchTasksDetails();
    }
  }, [state?.user]);

  return (
    <div className="mt-3 flex h-full w-full flex-col gap-[20px] rounded-[20px]">
      {loadingTask ? (
        <div className="flex h-64 items-center justify-center">
          <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-blue-500" />
        </div>
      ) : (
        <RemainingTasks incompleteTasks={task} />
      )}
    </div>
  );
};

export default Index;
